module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.unit)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.unit),
      expression: "item.unit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "unit", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.unit) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.unit))]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.amount)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.amount),
      expression: "item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.amount) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.price)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.price),
      expression: "item.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_regon"
    },
    domProps: {
      "value": (_vm.item.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.price) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.price))]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.netPrice))]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.currency)
    }
  }, [_c('dropdown-search', {
    attrs: {
      "elements": _vm.invoiceTaxType,
      "emptyValue": "Wybierz",
      "nameField": "name"
    },
    model: {
      value: (_vm.taxType),
      callback: function($$v) {
        _vm.taxType = $$v
      },
      expression: "taxType"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.currency) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_currency_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.currency))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.tax))]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm.grossPrice))]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "btn btn-icon btn-icon--warning",
    attrs: {
      "href": "#",
      "title": "Usuń"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeItem(_vm.index)
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dcbf090","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceItemForm.vue
// module id = 828
// module chunks = 0